import type { ComparisonContent } from './types'

/**
 * Light routing registry for the comparison pages — paths and language pairs
 * only, with the full content behind a dynamic `load()`.
 *
 * Exists because `index.ts` (which imports every content module eagerly) was
 * imported by `router/index.tsx` and `lib/marketingPages.ts`, both of which sit
 * in the app's entry chunk — so every logged-in studio member downloaded and
 * parsed all four comparison articles on every page load (D1 perf sweep,
 * 2026-08-20). Client code on the critical path imports THIS module; the eager
 * `index.ts` stays for the node-side prerender/OG scripts (marketingCatalogue),
 * where bundle weight is irrelevant.
 *
 * The path/alternates strings are duplicated from the content modules on
 * purpose (importing them here would defeat the split). The duplication is
 * pinned by `comparisonRegistry.test.ts`, which loads every entry and asserts
 * the registry row matches the content module — drift fails CI.
 */
export interface ComparisonRegistryEntry {
  path: string
  alternates: { en: string; de: string }
  load: () => Promise<ComparisonContent>
}

export const COMPARISON_REGISTRY: ComparisonRegistryEntry[] = [
  {
    path: '/vergleich/pixieset-alternative',
    alternates: { en: '/compare/pixieset-alternative', de: '/vergleich/pixieset-alternative' },
    load: () => import('./pixiesetAlternativeDe').then(m => m.pixiesetAlternativeDe),
  },
  {
    path: '/compare/pixieset-alternative',
    alternates: { en: '/compare/pixieset-alternative', de: '/vergleich/pixieset-alternative' },
    load: () => import('./pixiesetAlternativeEn').then(m => m.pixiesetAlternativeEn),
  },
  {
    path: '/compare/honeybook-alternative-europe',
    alternates: { en: '/compare/honeybook-alternative-europe', de: '/vergleich/honeybook-alternative-europa' },
    load: () => import('./honeybookAlternativeEuropeEn').then(m => m.honeybookAlternativeEuropeEn),
  },
  {
    path: '/vergleich/honeybook-alternative-europa',
    alternates: { en: '/compare/honeybook-alternative-europe', de: '/vergleich/honeybook-alternative-europa' },
    load: () => import('./honeybookAlternativeEuropaDe').then(m => m.honeybookAlternativeEuropaDe),
  },
]
